export default function getDayOfWeek() {
    const istDate = new Date().toLocaleString('en-US', { 
      timeZone: 'Asia/Kolkata', 
      weekday: 'long' 
    });
    return istDate;
  }